import { Link } from '@morressier/alembic';
import { contactSupportMail } from 'src/utils/env';
export const MailToLink = ({
  email = contactSupportMail,
  children = contactSupportMail
}: {
  email?: string;
  children?: React.ReactNode;
}) => {
  return (
    <Link
      href={`mailto:${email}`}
      variant="primary"
      isExternal
      textStyle="textBody"
    >
      {children}
    </Link>
  );
};
